import { Component } from "react";
import { Input, Form, Divider } from "antd";
import { getLangList } from '@/lib/i18n';
import { ReButton } from "@/components/refineElement";
import { modalFromLayout } from "@/lib/antdElementFunction";
import { hasPermission } from "@/lib/permissionUtil";

interface props {
  form?: any;
  pathInfo: any;
  handleType: string;
  clickDelete: any;
}

class ModalPath extends Component<props> {
  busT: any = getLangList("bus");
  buttonT: any = getLangList("button");

  componentDidMount() {
    const { form, pathInfo, handleType } = this.props;
    const { schoolName } = pathInfo ?? {};

    if (handleType === 'update') {
      form.setFieldsValue({ schoolName });
    }
  }

  render() {
    const { form, handleType, clickDelete } = this.props;

    return (
      <Form
        className="admin-form"
        style={{ marginTop: 20 }}
        {...modalFromLayout}
        form={form}
      >
        <Form.Item
          label={this.busT.PATH}
          name="schoolName"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        {handleType === 'update' && hasPermission('BUS_DELETE') &&
          <>
            <Divider dashed />
            <Form.Item label={this.buttonT.DELETE}>
              <ReButton onClick={clickDelete} attributeObject={{ type: "danger" }} iconName='delete' />
            </Form.Item>
          </>
        }
      </Form >
    );
  }
}

export default ModalPath;